const {FormWrapper, FormFooterAgreement} = require("../../../../../../FormHandlers");
const {object, string} = require("yup");
const {AdminInputPassword} = require("../../../../../../FormInputs");
const React = require("react");

module.exports = ({onSubmit, close}) => {
  return (
    <FormWrapper
      schema={object({confirmBearer: string().required()})}
      onSubmit={({confirmBearer}) => onSubmit(confirmBearer)}
      onResult={close}
    >{(formCtx) => (
      <>
        <div className="mt20">
          <AdminInputPassword label="Password" name="confirmBearer" formCtx={formCtx} />
        </div>
        <FormFooterAgreement
          submitBtnData={{text: 'Proceed', formCtx}}
          additionalBtnsList={[{text: 'Cancel', onClick: close}]}
        />
      </>
    )}</FormWrapper>
  )
}
